var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.939 3.91464C1.91329 3.91464 0.271118 5.55681 0.271118 7.58252V12.2582C0.271118 14.8182 2.34642 16.8935 4.90643 16.8935H14.1771C16.7371 16.8935 18.8124 14.8182 18.8124 12.2582V7.58252C18.8124 5.55681 17.1702 3.91464 15.1445 3.91464C14.5576 3.91464 14.0272 3.56488 13.796 3.02543L13.5089 2.35555C13.0706 1.33295 12.0651 0.669922 10.9526 0.669922H9.54175H8.13093C7.01838 0.669922 6.01287 1.33295 5.57462 2.35555L5.28752 3.02543C5.05633 3.56488 4.5259 3.91464 3.939 3.91464ZM11.6276 9.47696C11.6276 8.32495 10.6938 7.39107 9.54175 7.39107C8.38974 7.39107 7.45586 8.32495 7.45586 9.47696C7.45586 10.629 8.38974 11.5629 9.54175 11.5629C10.6938 11.5629 11.6276 10.629 11.6276 9.47696ZM9.54175 6.00047C11.4618 6.00047 13.0182 7.55695 13.0182 9.47696C13.0182 11.397 11.4618 12.9534 9.54175 12.9534C7.62174 12.9534 6.06526 11.397 6.06526 9.47696C6.06526 7.55695 7.62174 6.00047 9.54175 6.00047Z",
    fill: "#1F2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d2266c52f0320efc7d1c8eecbd103d9f.svg";
export { ForwardRef as ReactComponent };